export const mainColor = Object.freeze({
  black: '#333333',
  white: '#FFFFFF',
  red: '#FF3333',
  yellow: '#F08D32',
  blue: '#144CC7',
  green: '#49966E',
});

export const colorPalette = Object.freeze({
  white: {
    A50: '#FFFFFF',
    A75: 'rgba(255,255,255,0.7)',
    A80: '#E5E5E5',
    A100: '#CCCCCC',
    A125: '#C1C1C1',
    A150: '#B2B2B2',
    A200: '#D9D9D9',
    A300: '#6F6F6F',
  },
  black: {
    A50: '#EFF3FA',
    A100: '#7E7E7E',
    A200: '#4B4B4B',
    A300: '#2B2B2B',
    A400: '#191919',
    A500: '#354733',
    A600: '#333333',
    A700: '#212529',
    A800: '#000000',
    A900: '#000000CC',
  },
  green: {
    A100: '#72BCAC',
    A200: '#42A690',
    A300: '#49966e',
    A400: '#10735D',
    A500: '#49966E',
    A600: '#91B87966',
    A601: '#91B87929',
  },
  dustGreen: {
    A100: '#D6D6C1',
    A200: '#C1C1A3',
    A300: '#ADAD84',
    A400: '#999966',
    A500: '#807f50',
  },
  error: {
    A100: '#DB704C',
    A200: '#D65B32',
    A300: '#D14719',
    A400: '#CC3300',
    A500: '#D11124',
    A600: '#E24329',
    A700: '#EB1C2A',
  },
  warning: {
    A100: '#FFB793',
    A200: '#FFAD84',
    A300: '#FFA375',
    A400: '#FF9966',
  },
  success: {
    A100: '#70B74C',
    A200: '#5BAD32',
    A300: '#47A319',
    A400: '#339900',
  },
  prompt: {
    A100: '#EDBB4A',
    A200: '#F18D01',
    A300: '#FFF3D9',
  },
  orange: {
    A100: '#E9630C',
    A200: '#B14F4F',
    A300: '#FDECE4',
  },
  blue: {
    A100: '#F2F5FA',
  },
});
